import { AuthComponent } from './auth.component';
import { Routes } from '@angular/router';
import { AUTH_ROUTE_NAMES } from './auth.routes.names';
import { ExternalRoutesGuard } from '@app/core/guards/external-routes-guard/external-routes.guard';

export const AUTH_ROUTES: Routes = [
  {
    path: '',
    component: AuthComponent,
    canActivate: [ExternalRoutesGuard],
    children: [
      {
        path: AUTH_ROUTE_NAMES.LOGIN,
        loadChildren: '@modules/auth/pages/sign-in/sign-in.module#SignInModule',
        data: {
          depth: 1,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.ACTIVATE_ACCOUNT,
        loadChildren:
          '@modules/auth/pages/activate-account/activate-account.module#ActivateAccountModule',
        data: {
          depth: 2,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.VERIFY_ACCOUNT,
        loadChildren:
          '@modules/auth/pages/verify-account/verify-account.module#VerifyAccountModule',
        data: {
          depth: 3,
          firstUserAccessProcessRoute: true,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.VERIFY_PHONE,
        loadChildren:
          '@modules/auth/pages/verify-phone/verify-phone.module#VerifyPhoneModule',
        data: {
          depth: 2,
          firstUserAccessProcessRoute: true,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.CONFIRM_PHONE,
        loadChildren:
          '@modules/auth/pages/confirm-security-code/confirm-security-code.module#ConfirmSecurityCodeModule',
        data: {
          depth: 3,
          firstUserAccessProcessRoute: true,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.FORGOT_MY_PASSWORD,
        loadChildren:
          '@modules/auth/pages/forgot-my-password/forgot-my-password.module#ForgotMyPasswordModule',
        data: {
          depth: 2,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.UPDATE_MY_PASSWORD,
        loadChildren:
          '@modules/auth/pages/forgot-my-password/update-my-password/update-my-password.module#UpdateMyPasswordModule',
        data: {
          depth: 2,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.UPDATE_REGISTRATION_INFORMATION,
        loadChildren:
          '@modules/auth/pages/update-registration-information/update-registration-information.module#UpdateRegistrationInformationModule',
        data: {
          depth: 1,
          firstUserAccessProcessRoute: true,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.CREATE_PASSWORD,
        loadChildren:
          '@modules/auth/pages/create-password/create-password.module#CreatePasswordModule',
        data: {
          depth: 2,
          firstUserAccessProcessRoute: true,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.UPDATE_PASSWORD,
        loadChildren:
          '@modules/auth/pages/update-password/update-password.module#UpdatePasswordModule',
        data: {
          depth: 2,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.ASSISTED_MODE,
        loadChildren:
          '@modules/auth/pages/assisted-mode/assisted-mode.module#AssistedModeModule',
        data: {
          depth: 1,
        },
      },
      {
        path: AUTH_ROUTE_NAMES.ASSISTED_MODE_CLIENT_LOGIN,
        loadChildren:
          '@modules/auth/pages/assisted-mode-client-login/assisted-mode-client-login.module#AssistedModeClientLoginModule',
        data: {
          depth: 1,
        },
      },
    ],
  },
];
